var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCodeBranch = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 5.625C20 3.898 18.135 2.5 15.833 2.5s-4.166 1.398-4.166 3.125c0 1.422 1.265 2.621 2.995 3-.032.629-.22 1.113-.574 1.441-.801.75-2.567.875-4.437 1.004-1.469.102-2.99.211-4.234.66V6.105c1.692-.398 2.916-1.582 2.916-2.98C8.333 1.398 6.47 0 4.167 0S0 1.398 0 3.125c0 1.398 1.224 2.582 2.917 2.98v7.786C1.224 14.293 0 15.477 0 16.875 0 18.602 1.865 20 4.167 20s4.166-1.398 4.166-3.125c0-1.328-1.104-2.465-2.666-2.914.161-.203.406-.383.776-.524.843-.32 2.104-.406 3.442-.5 2.198-.152 4.688-.328 6.157-1.695.729-.68 1.099-1.555 1.125-2.652C18.812 8.168 20 7 20 5.625M4.167 2.5c.458 0 .833.281.833.625s-.375.625-.833.625c-.459 0-.834-.281-.834-.625s.375-.625.834-.625m0 15c-.459 0-.834-.281-.834-.625s.375-.625.834-.625.833.281.833.625-.375.625-.833.625M15.833 5c.459 0 .834.281.834.625s-.375.625-.834.625S15 5.969 15 5.625 15.375 5 15.833 5"
  })));
};
export { SvgCodeBranch as ReactComponent };